// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7BdMn","comment":"styles_comment__3_XrP"};